import { useRef } from 'react';
import { VyTableColumnSettings } from '../../../../components/new-design/table/table-column-settings/VyTableColumnSettings';
import { VyTableColumnSettingsButton } from '../../../../components/new-design/table/vy-table-column-settings-button/VyTableColumnSettingsButton';
import {
  type FilterField,
  type FilterLineType,
} from '../../../../components/new-design/vyTableFilter';
import type { ColumnConfig } from '../../../../hooks/use-grid-column-settings';
import { RevenueReportToolbar } from '../../reports-components/RevenueReportToolbar';

type UsageReportV2ReportToolbarProps = {
  onSearchChange: (value: string) => void;
  searchDefaultValue?: string;
  fromDate: Date | null;
  onFromDateChange: (date: Date | null) => void;
  toDate: Date | null;
  onToDateChange: (date: Date | null) => void;
  filterFields: FilterField[];
  filters: FilterLineType[];
  onFiltersChange: (filters: FilterLineType[]) => void;
  onExport: () => void;
  onRefresh: () => void;
  isRefreshing: boolean;
  isColumnSettingsOpen: boolean;
  onOpenColumnSettings: () => void;
  onCloseColumnSettings: () => void;
  columnSettings: ColumnConfig[];
  onColumnVisibilityChange: (field: string, isVisible: boolean) => void;
};

export const UsageReportV2ReportToolbar: React.FC<UsageReportV2ReportToolbarProps> = ({
  onSearchChange,
  searchDefaultValue,
  fromDate,
  onFromDateChange,
  toDate,
  onToDateChange,
  filterFields,
  filters,
  onFiltersChange,
  onExport,
  onRefresh,
  isRefreshing,
  isColumnSettingsOpen,
  onOpenColumnSettings,
  onCloseColumnSettings,
  columnSettings,
  onColumnVisibilityChange,
}) => {
  const columnSettingsAnchorRef = useRef<HTMLDivElement | null>(null);

  const trailingActions = (
    <>
      <div ref={columnSettingsAnchorRef}>
        <VyTableColumnSettingsButton onClick={onOpenColumnSettings} />
      </div>
      <VyTableColumnSettings
        anchorEl={columnSettingsAnchorRef.current}
        open={isColumnSettingsOpen}
        onClose={onCloseColumnSettings}
        columns={columnSettings}
        handleColumnVisibilityChange={onColumnVisibilityChange}
      />
    </>
  );

  return (
    <RevenueReportToolbar
      onSearchChange={onSearchChange}
      searchValue={searchDefaultValue}
      searchLabel="Search"
      searchPlaceholder="Search by Customer, Contract or Product"
      fromDate={fromDate}
      onFromDateChange={onFromDateChange}
      toDate={toDate}
      onToDateChange={onToDateChange}
      useDateRangePicker
      filterFields={filterFields}
      filters={filters}
      onFiltersChange={onFiltersChange}
      hideChartToggle
      trailingActions={trailingActions}
      onExport={onExport}
      onRefresh={onRefresh}
      isRefreshing={isRefreshing}
    />
  );
};
